import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'credit-policies-real-estate-developments',
  storeModule.createStoreModule('credit-policies-real-estate-developments')
)
